import Point from './point';

export default class PointEdit extends Point {
    constructor(map, data, changeGeofencePoints) {
        super(map, data, null);
        this.changeGeofencePoints = changeGeofencePoints;
        this.addCircle();

        map.on('editable:drawing:start', () => {
            this.removeCirle();
        });

        map.on('editable:drawing:end', () => {
            this.removeCirle();
            this.addCircle();
            this.changeGeofencePoints(this.getCoords());
        });

        map.on('editable:dragstart', () => {
            this.removeCirle();
        });

        map.on('editable:dragend', () => {
            this.addCircle();
            this.changeGeofencePoints(this.getCoords());
        });

        this.on("remove", () => {
            this.removeCirle();
            this.map.off('editable:drawing:start');
            this.map.off('editable:drawing:end');
            this.map.off('editable:dragstart');
            this.map.off('editable:dragend');
        });
    }

    onClick() { }

    onOver() { }

    onOut() { }

    addCircle() {
        this.onOverCircle = new L.circle(
            this.getLatLngs()[0],
            parseInt(this.radius),
            {
                interactive: false,
                fill: true,
                fillColor: '#00599F',//e.target.color,
                color: '#00599F',//e.target.color,
                weight: 3,
            });
        this.map.addLayer(this.onOverCircle);
    }

    startEdit() {
        if (this.id === '0') {
            this.enableEdit().startDrawing();
        }
        else {
            this.enableEdit();
        }
    }

    removeCirle() {
        this.map.removeLayer(this.onOverCircle);
    }

    updateData(data) {
        this.name = data.name;
        this.unbindTooltip();
        if (this.name) {
            this.bindTooltip(this.name);
        }
        if (!data.dataForMap.radius || data.dataForMap.radius === "") {
            data.dataForMap.radius = 0;
        }
        this.radius = data.dataForMap.radius;
        this.onOverCircle.setRadius(parseInt(this.radius));
        if (data.dataForMap.icon !== this.icon) {
            this.updateIcon(data.dataForMap.icon);
            this.icon = data.dataForMap.icon;
        }
    }

    getCoords() {
        let latLngs = this.getLatLngs().map(item => {
            return {
                lat: item.lat,
                lon: item.lng
            }
        })
        return latLngs;
    }
}
